module.controller('confirmationCtrl', ['bankToAddService', function(bankToAddService) {

    var vm = this;

    vm.bank = bankToAddService.get();
    vm.accounts = bankToAddService.getAccounts();

}]);
